// ⚠️ WARNING: change import order carefully. apparently webpack or some other 
// tool has issues if import order does not follow a certain pattern here 
// and will lead to misleading and absurd error messages.

import { all } from "redux-saga/effects";
import authSaga from "containers/Auth/Auth.saga";
import listingSaga from "components/Listing/Listing.saga";
import workspacesSaga from "containers/Workspaces/Workspaces.saga";
import statsSaga from "containers/Stats/Stats.saga";
import resourcesSaga from "containers/Resources/Resources.saga";
import metaTypeSaga from "containers/Resources/components/MetaType/MetaType.saga";
import wrappers from "containers/Resources/screens/ResourcesSingle/components/ResourceWrapper/WrapperList.saga";
import executionSaga from "containers/Executions/Executions.saga";
import latestEditsSaga from "components/Charts/LatestEdits/LatestEdits.saga";
import autocompleteSaga from "components/Form/components/Autocomplete/Autocomplete.saga";
import referenceLabelSaga from "components/Form/components/ReferenceLabel/ReferenceLabel.saga";
import pluginSaga from "components/PluginsPopover/Plugin.saga";
import identityRoleSaga from "containers/Auth/screens/IdentityManagement/IdentityRole.saga";
import bundlesSaga from "containers/BundleManager/Bundles.saga";
import workspaceSettingsSaga from "containers/WorkspaceSettings/WorkspaceSettings.saga";
import dataStoreSaga from "utils/DataStore/DataStore.saga";

export default function* rootSaga() {
    //  Core
    yield all([...authSaga]);
    yield all([...listingSaga]);
    //   App
    yield all([...workspacesSaga]);
    yield all([...workspaceSettingsSaga]);
    yield all([...statsSaga]);
    yield all([...resourcesSaga]);
    yield all([...metaTypeSaga]);
    yield all([...executionSaga]);
    yield all([...latestEditsSaga]);
    yield all([...autocompleteSaga]);
    yield all([...referenceLabelSaga]);
    yield all([...pluginSaga]);
    yield all([...wrappers]);
    yield all([...identityRoleSaga]);
    yield all([...bundlesSaga]);
    yield all([...dataStoreSaga]);
}
